import React from "react";
import styled from "styled-components";
import { EditGrayIcon } from "../../CommonUI/Icon/EditGrayIcon";

export const StyledEditButton = styled.div<{ hide?: boolean; right?: number }>`
    width: 16px;
    height: 16px;
    position: absolute;
    right: ${(props) => props.right || 0}px;
    top: 0;
    cursor: pointer;

    ${(props) => (props.hide ? "display: none;" : "display: block;")}
`;

interface EditButtonProps {
    onClick: () => void;
    hide?: boolean;
    className?: string;
    dataTestId?: string;
    right?: number;
}

export const EditButton = (props: EditButtonProps) => {
    return (
        <StyledEditButton
            onClick={props.onClick}
            className={props.className}
            hide={props.hide}
            data-testid={props.dataTestId}
            right={props.right}
        >
            <EditGrayIcon />
        </StyledEditButton>
    );
};
